import { render, staticRenderFns } from "./alluser.vue?vue&type=template&id=4b2eb6d2"
import script from "./alluser.vue?vue&type=script&lang=js"
export * from "./alluser.vue?vue&type=script&lang=js"
import style0 from "./alluser.vue?vue&type=style&index=0&id=4b2eb6d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports